module.exports = __webpack_public_path__ + "static/media/FouLogo.10afdab3.png";